import React, { useState, useEffect } from 'react';
import { Avatar, Typography, theme } from 'antd';
import { UserOutlined, LoadingOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import './styles.css';

const AvatarName = ({ photoUrl, name }) => {
	const [loading, setLoading] = useState(true);
	const {
		token: { colorPrimary },
	} = theme.useToken();
	const { Text } = Typography;

	useEffect(() => {
		if (photoUrl) {
			const img = new Image();
			img.src = photoUrl;
			img.onload = () => {
				setLoading(false);
			};
			img.onerror = () => {
				setLoading(false);
			};
		} else {
			setLoading(false);
		}
	}, [photoUrl]);

	return (
		<div className="avatar-name-container">
			{loading && (
				<LoadingOutlined
					style={{
						fontSize: '24px',
						color: colorPrimary,
					}}
				/>
			)}
			{!loading && (
				<Avatar
					style={{
						backgroundColor: photoUrl ? 'transparent ' : colorPrimary,
						color: 'white',
						flex: 'none',
					}}
					icon={<UserOutlined />}
					src={photoUrl}
					size="small"
				/>
			)}

			{name && (
				<Text
					className="fade-in"
					style={{
						fontWeight: 500,
						fontSize: '14px',
						color: colorPrimary,
						lineHeight: '1.2',
					}}
				>
					{name}
				</Text>
			)}
		</div>
	);
};

export default AvatarName;

AvatarName.defaultProps = {
	photoUrl: null,
	name: null,
};

AvatarName.propTypes = {
	photoUrl: PropTypes.string,
	name: PropTypes.string,
};
